<app-page-title icon="fa-bar-chart" title="Relatório de Envios por Provedor"></app-page-title>

<div class="provider-report">
  <section class="filters-bar">
    <div class="filters-row">
      <div class="filter-field">
        <mat-form-field appearance="fill">
          <mat-label>Data início</mat-label>
          <input
            matInput
            [matDatepicker]="pickerStart"
            [(ngModel)]="startDate"
            name="startDate"
          />
          <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
          <mat-datepicker #pickerStart></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="filter-field">
        <mat-form-field appearance="fill">
          <mat-label>Data fim</mat-label>
          <input
            matInput
            [matDatepicker]="pickerEnd"
            [(ngModel)]="endDate"
            name="endDate"
          />
          <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="filter-field">
        <mat-form-field appearance="fill">
          <mat-label>Provedor</mat-label>
          <mat-select [(ngModel)]="selectedProviderId" name="providerId">
            <mat-option [value]="null">Todos</mat-option>
            <mat-option *ngFor="let provider of providers" [value]="provider.id">
              {{ provider.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-actions">
        <button class="btn btn-primary" type="button" (click)="filter()" [disabled]="loading">
          <i class="fa fa-search"></i> Filtrar
        </button>
        <button class="btn btn-outline-secondary" type="button" (click)="clear()" [disabled]="loading">
          Limpar
        </button>
      </div>
    </div>
  </section>

  <!-- Duas formas porque a tela tem duas: a fileira de totais e a lista de
       provedores. Só o primeiro esqueleto leva rótulo — dois `role="status"`
       falando ao mesmo tempo anunciariam o carregamento em dobro. -->
  <div *ngIf="loading" data-testid="provider-report-loading">
    <app-skeleton variant="card" [count]="3" label="Carregando o relatório de provedores"></app-skeleton>
    <app-skeleton variant="table-row" [count]="6" [columns]="5" label=""></app-skeleton>
  </div>

  <ng-container *ngIf="!loading">
    <div *ngIf="reportProviders.length > 0" class="totals-row">
      <div class="total-card primary">
        <div class="total-card-label">Total enviado (SMSFunnel)</div>
        <div class="total-card-value">{{ totalSent | numberFormat }}</div>
        <div class="total-card-sub">
          <i class="fa fa-paper-plane-o"></i> Todos os provedores no período
        </div>
      </div>

      <div class="total-card">
        <div class="total-card-label">Provedores ativos</div>
        <div class="total-card-value">{{ activeProvidersCount }}</div>
        <div class="total-card-sub">
          <i class="fa fa-server"></i> {{ totalAccountsCount }} contas no total
        </div>
      </div>
    </div>

    <div *ngIf="reportProviders.length > 0" class="providers-summary-card">
      <div class="providers-summary-header">
        <i class="fa fa-list"></i>
        Total consolidado por provedor
      </div>
      <ul class="providers-summary-list">
        <li *ngFor="let provider of reportProviders" class="providers-summary-item">
          <span class="providers-summary-name">{{ provider.name }}</span>
          <span class="providers-summary-sent">
            {{ provider.total_sent | numberFormat }} enviados
          </span>
          <span class="providers-summary-pct">
            {{ provider.percentage | number:'1.1-1' }}%
          </span>
        </li>
      </ul>
    </div>

    <ng-container *ngIf="reportProviders.length > 0; else noData">
      <div
        *ngFor="let provider of reportProviders"
        class="provider-section"
      >
        <div class="provider-header" (click)="toggleAccordion(provider)">
          <span class="provider-name">{{ provider.name }}</span>
          <span class="provider-sent-badge">
            {{ provider.total_sent | numberFormat }} enviados
          </span>
          <span class="provider-share">
            {{ provider.percentage | number:'1.1-1' }}% do total
          </span>
          <i
            class="fa fa-chevron-down provider-chevron"
            [class.is-open]="provider.expanded"
          ></i>
        </div>

        <div class="provider-body" *ngIf="provider.expanded">
          <p class="provider-total-label">
            {{ provider.name }} — Total enviado pelo provedor
          </p>
          <p class="provider-total-value">
            <b>{{ provider.total_sent | numberFormat }}</b>
          </p>

          <table class="accounts-table">
            <thead>
              <tr>
                <th>Conta</th>
                <th class="text-right">Enviados</th>
                <th>% da conta no provedor</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let account of provider.accounts">
                <td class="account-name">{{ account.name }}</td>
                <td class="text-right account-sent">
                  {{ account.total_sent | numberFormat }}
                </td>
                <td>
                  <div class="account-bar-cell">
                    <div class="account-bar-track">
                      <div
                        class="account-bar-fill"
                        [style.width.%]="account.percentage"
                      ></div>
                    </div>
                    <span class="account-bar-pct">
                      {{ account.percentage | number:'1.1-1' }}%
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <ng-template #noData>
      <div class="empty-state">
        Nenhum dado encontrado para o período informado.
      </div>
    </ng-template>
  </ng-container>
</div>
